import React from 'react'

import { chainTypes } from 'constant'

const DuplicateNFTsHeader = () => {
  return (
    <thead className='hidden border-b md:table-header-group lg:table-header-group'>
      <tr className='flex flex-col flex-nowrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0'>
        <th className='text-left font-bold'></th>
        <th className='text-left p-4 font-bold'>Name & Collection ID</th>
        <th className='text-left p-4 font-bold'>Slug(s)</th>
        <th className='text-left p-4 font-bold'>Links</th>
        <th className='text-left p-4 font-bold'></th>
      </tr>
    </thead>
  )
}

export default DuplicateNFTsHeader
